<div class="flex justify-center px-4">
  <div class="container mx-auto">
    <div class="md:mt-32 mt-24 mx-auto">
      <div
        class="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 space-y-8 text-gray-700 leading-relaxed"
      >
        <h2 class="text-3xl font-extrabold mb-8 text-gray-900">
          Return & Refund Policy
        </h2>
        <p class="text-lg">
          Your satisfaction is important to us. Please review our return and
          refund policy before making a purchase.
        </p>

        <!-- Payment Methods -->
        <div class="border-l-4 border-[var(--primary)] pl-4">
          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            Payment Methods
          </h3>
          <ul class="list-disc pl-6 space-y-2">
            <li>We accept the following payment methods:</li>
            <ul class="list-disc pl-6 space-y-1">
              <li>Secure Payment Gateway (Card Payments)</li>
              <li>Bank Transfer</li>
              <li>Koko Payment (Buy Now, Pay Later)</li>
            </ul>
            <li>All payments must be completed before orders are processed.</li>
          </ul>
        </div>

        <!-- Return Eligibility -->
        <div class="border-l-4 border-[var(--primary)] pl-4">
          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            Return Eligibility
          </h3>
          <ul class="list-disc pl-6 space-y-2">
            <li>Returns are accepted only for damaged or defective items.</li>
            <li>You must notify us within 3–7 days of receiving the item.</li>
            <li>
              Customers are required to provide clear proof (photos or videos)
              of the damage.
            </li>
          </ul>
        </div>

        <!-- Non-Returnable Items -->
        <div class="border-l-4 border-[var(--primary)] pl-4">
          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            Non-Returnable Items
          </h3>
          <ul class="list-disc pl-6 space-y-2">
            <li>Items that are not damaged</li>
            <li>Change of mind after purchase</li>
            <li>
              Incorrect size selection (please check size charts carefully)
            </li>
            <li>Customized or printed products (unless damaged)</li>
            <li>
              Damage caused after delivery by the customer (e.g., misuse,
              accidents, improper handling)
            </li>
            <li>Normal wear and tear</li>
            <li>Minor variations in color or design</li>
          </ul>
        </div>

        <!-- Refund Process -->
        <div class="border-l-4 border-[var(--primary)] pl-4">
          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            Refund Process
          </h3>
          <ul class="list-disc pl-6 space-y-2">
            <li>
              Once your request is reviewed and approved, we will process your
              refund.
            </li>
            <li>
              Refunds may take a few business days depending on your payment
              method.
            </li>
            <li>
              Approved refunds will be issued to the original payment method
              where possible.
            </li>
            <li>
              For bank transfers, refunds will be sent to your provided bank
              account.
            </li>
          </ul>
        </div>

        <p class="text-sm text-gray-500 pt-4 border-t">
          Last updated: January 2026
        </p>
      </div>
    </div>
  </div>
</div>
